import { getChoresClient } from "../client";
import { getCurrentSelectedTenant } from "../utils";
import { ChoreList } from "../client/svcChores";

export const fetchUserChores = async (): Promise<ChoreList> => {
  const client = getChoresClient();

  const forTenant = getCurrentSelectedTenant();
  const { data, error } = await client.myChores(forTenant ?? undefined);
  if (error) {
    throw error;
  }
  return data;
};
